import { createContext } from "react";
import {
  ILoginResponse,
  IUserLoginResponse,
} from "../api/services/auth/models";
import { setRefreshToken } from "./api";
import { AuthConfig } from "./config/authConfig";

const calculateExpiryDate = (expiresIn: number) => {
  const time = new Date();
  time.setSeconds(time.getSeconds() + expiresIn);
  return time.toISOString();
};
const isExpired = () => {
  const now = new Date();
  const expiresAt = new Date(AuthConfig.getExpiresAt() || "");
  return expiresAt.getTime() - now.getTime() < 0;
};
export const getToken = async (): Promise<string | null> => {
  if (isExpired()) {
    await setRefreshToken();
  }
  return AuthConfig.getToken();
};
export const contextUserLogin = (data: IUserLoginResponse) => {
  AuthConfig.setUserInfo(data.user);
  AuthConfig.setToken(data.access_token);
  AuthConfig.setRefreshToken(data.refresh_token);
  data.expires_in &&
    AuthConfig.setExpiresAt(calculateExpiryDate(data.expires_in));
};
export const isLoggedIn = () => {
  const token = AuthConfig.getToken();
  if (token != null) return true;
  return false;
};
export const logOut = () => {
  AuthConfig.setUserInfo(null);
  AuthConfig.setToken(null);
  AuthConfig.setRefreshToken(null);
  AuthConfig.setExpiresAt(null);
};
export const AppLogin = (data: ILoginResponse) => {
  AuthConfig.setAppToken(data.access_token);
};
export const isAppAuthenticated = () => {
  const token = AuthConfig.getAppToken();
  if (token != null) return true;
  return false;
};
export const UserContext = createContext({
  isLoggedIn: isLoggedIn,
  logOut: logOut,
  isAppAuthenticated: isAppAuthenticated,
});
